export default __webpack_public_path__ + "static/media/825.73e12122.png";